import HeadMeta from 'components/common/HeadMeta'
import { securityPrivacyPageMeta } from 'components/common/schema'
import Template from 'components/security-privacy/SecurityPrivacy'

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <HeadMeta {...securityPrivacyPageMeta} />
      <Template />
    </>
  )
}

export default PrivacyPolicy
